import 'dayjs/locale/ca';
import 'dayjs/locale/cs';
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/sl';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/pl';
import 'dayjs/locale/tr';
import 'dayjs/locale/da';

export const langText = {
  ca: { wind: 'Vent', humidity: 'Humitat' },
  cs: { wind: 'Vítr', humidity: 'Vlhkost' },
  en: { wind: 'Wind', humidity: 'Humidity' },
  es: { wind: 'Viento', humidity: 'Humedad' },
  de: { wind: 'Windstärke', humidity: 'Feuchtigkeit' },
  sl: { wind: 'Hitrost vetra', humidity: 'Vlažnost' },
  ja: { wind: '風', humidity: '湿度' },
  zh_tw: { wind: '風速', humidity: '濕度' },
  ru: { wind: 'Ветер', humidity: 'Влажность' },
  uk: { wind: 'Вітер', humidity: 'Вологість' },
  fr: { wind: 'Vent', humidity: 'Humidité' },
  it: { wind: 'Vento', humidity: 'Umidità' },
  pl: { wind: 'Wiatr', humidity: 'Wilgotność powietrza' },
  tr: { wind: 'Rüzgar', humidity: 'Nem Oranı' },
  da: { wind: 'Vind', humidity: 'Luftfugtighed' },
};
